<template>
  <div>
    <SelectZoom v-if="!exclude.includes('zoom')" />

    <MapBounds v-if="!exclude.includes('bounds')" />

    <BasemapConfig
      :basemap-type.sync="basemapType"
      :basemap-default.sync="basemapDefault"
      :custom-url.sync="customUrl"
      :custom-attribution.sync="customAttribution"
    />

    <MapPopupSettings />

    <MapLegendsConfig />

    <GeometryFill />

    <GeometryBorder />

    <CustomMarker />

    <GeometryAlias />
  </div>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { MAP_CONFIG_KEY } from '@/constants'
import SelectZoom from '@/components/builder/MapSettings/SelectZoom.vue'
import MapBounds from '@/components/builder/MapSettings/MapBounds.vue'
import BasemapConfig from '@/components/builder/MapSettings/BasemapConfig.vue'
import MapPopupSettings from '@/components/builder/MapSettings/MapPopupSettings.vue'
import MapLegendsConfig from '@/components/builder/GeometryStyle/MapLegendsConfig.vue'
import GeometryBorder from '@/components/builder/GeometryStyle/GeometryBorder.vue'
import GeometryFill from '@/components/builder/GeometryStyle/GeometryFill.vue'
import CustomMarker from '@/components/builder/GeometryStyle/CustomMarker.vue'
import GeometryAlias from '@/components/builder/GeometryAlias.vue'

import { MapConfig } from '@/types'

const components = {
  SelectZoom,
  MapBounds,
  BasemapConfig,
  MapLegendsConfig,
  GeometryBorder,
  GeometryFill,
  CustomMarker,
  GeometryAlias,
  MapPopupSettings,
}

const props = {
  exclude: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
}

@Component({ components })
export default class MapSettings extends Vue.extend({ props }) {
  get basemapType () {
    return this.$typedStore.primary.app.config.mapConfig.basemapType
  }

  set basemapType (value) {
    this.updateMapConfig(value, 'basemapType')
  }

  get basemapDefault () {
    return this.$typedStore.primary.app.config.mapConfig.basemapDefault
  }

  set basemapDefault (value) {
    this.updateMapConfig(value, 'basemapDefault')
  }

  get customUrl () {
    return this.$typedStore.primary.app.config.mapConfig.basemapCustom.url
  }

  set customUrl (value) {
    this.updateMapConfig(value, 'basemapCustom', 'url')
  }

  get customAttribution () {
    return this.$typedStore.primary.app.config.mapConfig.basemapCustom.attribution
  }

  set customAttribution (value) {
    this.updateMapConfig(value, 'basemapCustom', 'attribution')
  }

  updateMapConfig (value: unknown, ...args: [keyof MapConfig] | ['basemapCustom', 'url' | 'attribution']) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [MAP_CONFIG_KEY, ...args],
      value,
    })
  }
}

</script>
